import { render, staticRenderFns } from "./questionTest.vue?vue&type=template&id=49f2d980&"
import script from "./questionTest.vue?vue&type=script&lang=js&"
export * from "./questionTest.vue?vue&type=script&lang=js&"
import style0 from "./questionTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports